import countryList from "constants/countryList";

const parseCallingCodeNumber = (callingCode: string) => {
  const n = Number.parseInt(String(callingCode).replace(/[^\d]/g, ""), 10);
  return Number.isFinite(n) ? n : 0;
};

interface countryCodeOptionType {
  key: string;
  text: string;
  value: string;
}

export const CountryCodeOptions = () => {
  return [...countryList]
    .filter((country: any) => Boolean(country?.countryCode))
    .sort((a: any, b: any) => {
      const aNum = parseCallingCodeNumber(a.countryCode);
      const bNum = parseCallingCodeNumber(b.countryCode);
      if (aNum !== bNum) return aNum - bNum;
      return String(a.text).localeCompare(String(b.text));
    })
    .map((country: any) => {
      return {
        key: `${country.key}-${country.countryCode}`,
        text: `${country.countryCode} ${country.text}`,
        value: country.countryCode,
      };
    });
};
